import React from 'react';
import { Tabs } from 'antd';
import RequestBlock from "./RequestBlock";
const { TabPane } = Tabs;

function Historical() {
    return (
           <>
               <Tabs >
                   <TabPane tab="Seleccionar" key="1"  >
                       <RequestBlock/>
                   </TabPane>
                   //TODO: Add Requests View in next version
               </Tabs>
           </>
    )
}
export default Historical;
